module.exports = __webpack_public_path__ + "static/media/AER_AI_340_AND_380_VISUALIZED.a5d6e299.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/utils/legend/AER_AI_340_AND_380_VISUALIZED.PNG
// module id = 1068
// module chunks = 0